import * as ProjectAPI from 'api/project-api';
import { txt } from 'libs/i18n';
const handleMessageOnSave = (descriptionResult, message) => {
    if (descriptionResult.isSuccess()) {
        void message.success(txt('metadataSaved'));
        return;
    }
    if (descriptionResult.err() === 'conflict') {
        void message.error(txt('conflictError'));
        return;
    }
    void message.error(txt('failedToSaveNotes'));
};
const getDateTimeValue = (value, fallback) => {
    if (value === undefined) {
        return fallback;
    }
    if (value === null) {
        return null;
    }
    return value.format();
};
export const updateProjectDescription = async ({ connection, projectId, currentDescription, updates, enqueueProjectUpdate, message, onSuccess, }) => {
    await enqueueProjectUpdate(async (initialProject) => {
        const projectDescription = {
            current: {
                author: currentDescription.author,
                start: currentDescription.start,
                notes: currentDescription.notes,
            },
            new: {
                author: updates.author !== undefined ? updates.author : currentDescription.author,
                start: getDateTimeValue(updates.start, currentDescription.start),
                notes: updates.notes !== undefined ? updates.notes : currentDescription.notes,
            },
        };
        const descriptionResult = await ProjectAPI.editProjectDescription(connection, projectId, projectDescription);
        if (descriptionResult.isSuccess()) {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            handleMessageOnSave(descriptionResult, message);
            return descriptionResult.get();
        }
        handleMessageOnSave(descriptionResult, message);
        return initialProject;
    });
};
